import { useState } from 'react'
import { Helmet } from 'react-helmet-async'

import PlanCard, { ENTERPRISE_PLAN, PRO_PLAN } from './PlanCard'

import styles from './Payment.module.scss'

import wisprLogo from '@/assets/images/wisprLogo.svg?url'
import { Spinner } from '@/components/Spinner'
import { useCheckoutSession } from '@/hooks/useCheckoutSession'
import { usePricing } from '@/hooks/usePricing'
import Nav from '@/pages/app/AppLayout/Nav'
import { PaymentSchedule, PlanType } from '@/types'

const PaymentPage = () => {
  const [schedule, setSchedule] = useState<PaymentSchedule>(PaymentSchedule.Annual)

  const { createCheckoutSession, status } = useCheckoutSession()
  const { currency } = usePricing()

  const planList = (
    <div className={styles.planList}>
      <PlanCard plan={PRO_PLAN} schedule={schedule} onClick={() => createCheckoutSession(PlanType.Pro, schedule)} />
      <PlanCard
        plan={ENTERPRISE_PLAN}
        schedule={schedule}
        onClick={() => createCheckoutSession(PlanType.Enterprise, schedule)}
      />
    </div>
  )

  return (
    <>
      <Helmet>
        <title>Wispr Flow | Set up</title>
      </Helmet>
      <div className={styles.root}>
        <Nav preSetup />
        <div className={styles.container}>
          <div className={styles.authWrapper}>
            <img src={wisprLogo} alt="Wispr" />
            <h5>Select your plan</h5>
            <div className={styles.scheduleToggle}>
              <div
                className={schedule == PaymentSchedule.Monthly ? styles.active : ''}
                onClick={() => setSchedule(PaymentSchedule.Monthly)}
              >
                Monthly
              </div>
              <div
                className={schedule == PaymentSchedule.Annual ? styles.active : ''}
                onClick={() => setSchedule(PaymentSchedule.Annual)}
              >
                Annual
              </div>
            </div>
            {status === 'loading' ? <Spinner size={40} color="black" /> : planList}
            <div className={styles.disclaimer}>
              All prices are in {currency?.toUpperCase() || 'USD'}. <br />
              Need a custom plan for your company? <a href="mailto:enterprise@wisprflow.ai">Contact us</a>.
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PaymentPage
